var navHelper = new (function NavHelper($) {
	var offset = 0;
	var startFrom = 0;
	var ignoreHashChange = false;
	
	var goToSection = function(id) {
		scrollToEl($(id), offset);
	};
	
	var isLinkOnCurrentPage = function(destUrl){
		var hostIdx = destUrl.indexOf(window.location.host);
		var path;
		var hashIdx;
		if(hostIdx > -1) {
			path = destUrl.slice(hostIdx+window.location.host.length);
			hashIdx = path.indexOf('#');
			if(hashIdx > -1) {
				path = path.slice(0, hashIdx);
			}
			return window.location.pathname === path;
		}
		return false;
	};
	
	this.initLinks = function($parent, callback) {
		$parent.find('a[href*="#"]').click({callback: callback}, function(e) {
			var destUrl = $(this).attr('href') 
			var currentUrl = window.location.origin + window.location.pathname;
			var splitedDestUrl = destUrl.split('#')
			var $destEl;
			var scrollOffset = offset;
			if(splitedDestUrl[1].length > 0) {
				$destEl = $('#'+splitedDestUrl[1]);
			} else {
				isLinkOnCurrentPage(destUrl);
				if(isLinkOnCurrentPage(destUrl)) {
					$destEl = $('body');
					scrollOffset = 0;
				}
			}
			
			
			var out = true;
			
			if($destEl && $destEl.length > 0 ) {
				scrollToEl($destEl, scrollOffset);
				ignoreHashChange = true;
				window.location.hash = '#'+destUrl.split('#')[1];
				out = false;
			}
			
			if(e.data.callback) {
				e.data.callback.call(this);
			}
			
			return out;
		});
	};
	
	this.goToElement = function($destEl) {
		scrollToEl($destEl, offset);
	}
	
	jQuery(document).ready(function($) {
		this.initLinks($('body'));
		
		offset += $('.nav-top__branding').height();
		
		if(window.location.hash !== '') {
			var $el;
			
			if(window.location.hash.indexOf('/') === -1) {
				$el = $(window.location.hash);
				if($el.length > 0) {
					scrollTo(0, startFrom);
					scrollToEl($el, offset);
				}
			}
		}
	}.bind(this));
	
})(jQuery);



